import antd, { Form, Collapse, Row } from 'antd';
import styled from 'styled-components';
import CollapsePanel from 'antd/lib/collapse/CollapsePanel';
import { ColSize } from 'antd/lib/col';

declare type ColSpanType = ColSize;

//in use
export const StyleCargoChargesSearch = styled(Form)`
  // margin: 80px;
  display: inline;
  background-color: orange;

  button {
    width: 150px;
  }
`;

export const ButtonColLayout: { [key: string]: ColSpanType } = {
  xxs: { span: 18 },
  xs: { span: 18 },
  sm: { span: 18 },
  md: { span: 18 },
  lg: { span: 10 },
  xl: { span: 8 },
  xxl: { span: 8 },
};